/***
 * 
 * COMPONENTE DINAMICO DE CABECERA
 * 
 */

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const HeadLine = ({ title = 'Default', backurl }) => {

    const { btnPrimaryColor } = useSelector((store: any) => (store.ui));

    const navigate = useNavigate();

    const backIcon = <FontAwesomeIcon icon={faAngleLeft} color='#000000' size='lg' />

    return (

        <div className='flex justify-between items-center p-4 headline-hi' style={{ background: btnPrimaryColor }}>
            <div className='cursor-pointer' onClick={() => { navigate(backurl) }}>
                {backIcon}
            </div>
            <div className='title-head-hi'>
                {title}
            </div>
            <div className="invisible">
                space
            </div>
        </div>


    )
}

HeadLine.propTypes = {
    title: PropTypes.string,
    backurl: PropTypes.string
}

